# graphics just uses graphicx

import './graphicx': { Graphicx }

export Graphics = Graphicx